var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckboxSelected = function SvgCheckboxSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 4,
    fill: "#1780EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13 6-5.5 5.5L5 9",
    stroke: "#fff",
    strokeWidth: 1.719,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
};
export default SvgCheckboxSelected;